document.addEventListener("DOMContentLoaded", function () {
  // Get zipcodes from the hidden element in DOM
  const zipcodeDataElement = document.getElementById("zipcode-data");
  const validZipcodes = zipcodeDataElement
    ? zipcodeDataElement.dataset.zipcodes.split(",").map((z) => z.trim())
    : [];

  const zipcodeInput = document.getElementById("zipcode-input");
  const zipcodeCheckBtn = document.getElementById("zipcode-check-btn");
  const zipcodeMessage = document.getElementById("zipcode-message");
  const zipcodeSuggestions = document.getElementById("zipcode-suggestions");
  const submitButton = document.querySelector(".button--zip-verifier");

  // Initialize with button disabled
  if (submitButton) {
    submitButton.disabled = true;
  }

  // Show suggestions based on input
  zipcodeInput.addEventListener("input", function () {
    const input = this.value.trim();
    zipcodeSuggestions.innerHTML = "";

    if (input.length > 0) {
      const matches = validZipcodes.filter((zip) => zip.startsWith(input));

      if (matches.length > 0) {
        matches.forEach((match) => {
          const suggestion = document.createElement("div");
          suggestion.textContent = match;
          suggestion.addEventListener("click", function () {
            zipcodeInput.value = match;
            zipcodeSuggestions.style.display = "none";
            checkZipcode(match);
          });
          zipcodeSuggestions.appendChild(suggestion);
        });
        zipcodeSuggestions.style.display = "block";
      } else {
        zipcodeSuggestions.style.display = "none";
      }
    } else {
      zipcodeSuggestions.style.display = "none";
    }
  });

  // Check button click handler
  zipcodeCheckBtn.addEventListener("click", function () {
    checkZipcode(zipcodeInput.value.trim());
  });

  // Also check when pressing Enter
  zipcodeInput.addEventListener("keypress", function (e) {
    if (e.key === "Enter") {
      checkZipcode(this.value.trim());
    }
  });

  // Close suggestions when clicking outside
  document.addEventListener("click", function (e) {
    if (
      !zipcodeInput.contains(e.target) &&
      !zipcodeSuggestions.contains(e.target)
    ) {
      zipcodeSuggestions.style.display = "none";
    }
  });

  // Check if zipcode is valid
  function checkZipcode(zipcode) {
    zipcodeMessage.textContent = "";
    zipcodeMessage.className = "zipcode-message";
    zipcodeSuggestions.style.display = "none";

    if (validZipcodes.includes(zipcode)) {
      zipcodeMessage.textContent = "Delivery available to your area!";
      zipcodeMessage.classList.add("success-message");

      // Enable the submit button
      if (submitButton) {
        submitButton.disabled = false;
      }
    } else {
      zipcodeMessage.textContent = "Sorry, we cannot deliver to that area";
      zipcodeMessage.classList.add("error-message");

      // Keep the submit button disabled
      if (submitButton) {
        submitButton.disabled = true;
      }
    }
  }
});
